export default __webpack_public_path__ + "static/undraw_Puzzle-06e1e1d6c6fb0c9e9023a937ad65062c.svg";